// extracted by mini-css-extract-plugin
export default {"languageContextualOption":"MC4UIgUv2yIj9KEf4Wv0","selectorWidth":"RRJAcdCFqEPA9RF0pOoD","languagesPopup":"ZDp_fJRHCCVrfZekTHvP"};